import fr from '@/translations/fr.json';
import en from '@/translations/en.json';
import { createI18n } from 'vue-i18n';

// The message table is the list of available locales, so adding one means adding its JSON here
// and nothing else -- no type to widen in the store, in IAppConfig or in the toggle.
//
// The keys are kept as they are, malformed as locale codes: BCP-47 wants `fr-FR` and `en-US`,
// with a hyphen and a real region. Correcting them would change IAppConfig, which is the
// contract the host application sends its config through, so it is a separate decision.
const MESSAGES = {
    en_En: en,
    fr_Fr: fr,
};

const DEFAULT_LOCALE: TLocale = 'fr_Fr';

type TLocale = keyof typeof MESSAGES;

const i18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    allowComposition: true,
    messages: MESSAGES,
});

// The locales the app can switch to, in the order the toggle walks them.
const AVAILABLE_LOCALES = Object.keys(MESSAGES) as TLocale[];

const { t } = i18n.global;

export { AVAILABLE_LOCALES, DEFAULT_LOCALE, i18n, t };
export type { TLocale };
